const WorkExperienceDAta = [
    {
        heading: "Full Time, Zithara.AI",
        timespan: "May 2024 - present",
        title: "Full Stack Developer",
    },
    {
        heading: "Full Time, Growpital",
        timespan: "May 2023 - May 2024",
        title: "Full Stack Developer",
    },
    {
        heading: "Internship, Agile RecruiTech LLP",
        timespan: "Oct 2022 - Apr 2023",
        title: "Frontend Developer",
    },
    {
        heading: "Internship, KGS Fintech Pvt. Ltd. (Capitall)",
        timespan: "Dec 2021 - May 2022",
        title: "Frontend Developer",
    },
    {
        heading: "Internship, Marstech",
        timespan: "May 2021 - Oct 2021",
        title: "Frontend Developer",
    },
    {
        heading: "Internship, Aiesys Pvt. Ltd.",
        timespan: "Jan 2021 - Mar 2021",
        title: "Frontend Developer",
    }
]
export default WorkExperienceDAta;
